export var DEFAULT_IFRAME_STYLES = {
    border: 'none',
    height: '512px',
    width: '768px',
    transition: 'height ease-out 200ms, width ease-out 200ms'
};
